import { stringFormatter } from "@kivunova/kivufrontendcommon";
import { PRODUCT_ITEM_STATE_KEYS } from "../constants/productItemStates";
import type { CategoryData } from "../types/dashboardTypes";

/** Full product-item state breakdown aligned with backend enum; missing API keys count as 0. */
export function buildProductItemStateMovement(
  productItemsByState: { key: string; value: number }[] | undefined
): CategoryData[] {
  const map = new Map<string, number>();
  PRODUCT_ITEM_STATE_KEYS.forEach((k) => map.set(k, 0));
  (productItemsByState ?? []).forEach((x) => map.set(x.key, x.value));
  return PRODUCT_ITEM_STATE_KEYS.map((k) => ({
    label: stringFormatter(k),
    value: map.get(k) ?? 0
  }));
}
